import { render, staticRenderFns } from "./PrivateAddress.vue?vue&type=template&id=16b2a3e5&"
import script from "./PrivateAddress.vue?vue&type=script&lang=js&"
export * from "./PrivateAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports